// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"339":"3b53517f","731":"122eb948"}[chunkId] + ".chunk.css";
};